import en from "./en";
// Italian - full translation of top-level nav + hero + CTA. Content sections use en fallback for now.
const it = {
  ...en,
  nav: {
    home: "Home",
    about: "L'Alleanza",
    markets: "Mercati",
    services: "Servizi",
    partners: "Partner",
    manufacturers: "Per i Costruttori",
    news: "News",
    contact: "Contatti",
    partner_cta: "Diventa Partner",
  },
  hero: {
    eyebrow: "European Electric Mobility Alliance",
    title_line1: "La Piattaforma Europea di Distribuzione",
    title_line2: "per la Mobilità Elettrica",
    subtitle: "Colleghiamo i costruttori alla rete di distribuzione più esperta d'Europa. Non importiamo semplicemente veicoli. Costruiamo marchi.",
    cta_primary: "Diventa Partner",
    cta_secondary: "Scopri l'Alleanza",
    scroll: "Scorri per scoprire",
  },
  cta_final: {
    eyebrow: "Partnership Strategica",
    title: "Pronto ad espanderti in Europa?",
    subtitle: "Collabora con EEMA e sfrutta una piattaforma commerciale consolidata che copre i mercati europei più strategici della mobilità elettrica.",
    button: "Richiedi un incontro",
  },
};
export default it;
